import LayoutHOC from "../LayoutHOC";
import Button from "../UniversalComponents/DefaultButton";
import VendorHeaderHoc from "./VendorHeaderHoc";
import React, { useState } from "react";
import Input from "../UniversalComponents/InputComponent";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as DownAngelBracket } from "../../assets/images/downAngleBracket.svg";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import Select from "../../components/UniversalComponents/SelectComponent";
import DatePicker from "react-datepicker";
import { Drawer } from "@mui/material";
import NewVendor from "./NewVendor";

const VendorAdd = () => {
  const [OpeningBalanceDate, setOpeningBalanceDate] = useState(null);

  const [selectedTermValue, setSelectedTermValue] = useState("");
  const [selectedDeExCatValue, setSelectedDeExCatValue] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isAddressFormOpen, setIsAddressFormOpen] = useState(false);
  const [isPaymentTabOpen, setIsPaymentTabOpen] = useState(false);
  const [isAddiInfoTabOpen, setIsAddiInfoTabOpen] = useState(false);
  const [isAddVendorVisible, setIsAddVendorVisible] = useState(false);

  const placeholder = "Select Date";
  const displayFormat = "dd-MM-yyyy";

  const selectTermName = [
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectDeExCatName = [
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];
  const selectCountry = [
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const handleTermSelectChange = (e) => {
    setSelectedTermValue(e.target.value);
  };
  const handleDeExCatSelectChange = (e) => {
    setSelectedDeExCatValue(e.target.value);
  };
  const handleCountrySelectChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  const formatDateForSaveAsOf = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${day}-${month}-${year}`;
  };

  const onChange = (date) => {
    setOpeningBalanceDate(date);

    const formattedPaymentDate = date ? formatDateForSaveAsOf(date) : "";

    // FieldChange({ payment_date: formattedPaymentDate });
  };

  const toggleVisibility = (e, setState) => {
    e.preventDefault();
    setState((prevState) => !prevState);
  };

  const handleAddAnotherAccount = () => {};
  const handleVendorSave = () => {};
  const handleVendorCancel = () => {};

  const [formData, setFormData] = useState({
    vendorName: "",
    vendorContactName: "",
    email: "",
    phoneNumber: "",
    mobileNumber: "",
    website: "",
    streetAddress1: "",
    streetAddress2: "",
    city: "",
    state: "",
    zipCode: "",
    bankName: "",
    bankAddress: "",
    accountName: "",
    accountNumber: "",
    nameToPrintonCheck: "",
    routingNumber: "",
    businessIDNo_SocialSecurityNo: "",
    account_Number: "",
    openingBalance: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleNewVendorClick = () => {
    setIsAddVendorVisible((prev) => !prev); // Toggle visibility
  };

  const closeAddVendor = () => {
    setIsAddVendorVisible(false); // Hide the AddVendor component
  };

  return (
    <div className="bg-F1F6F9">
      <div className="flex justify-end mx-10 ">
        {!isAddVendorVisible && (
          <Button
            type="primary"
            onClick={handleNewVendorClick}
            style={{
              margin: "1px",
              padding: "5px",
              height: "35px",
              borderRadius: "8px",
            }}
          >
            New Vendor
          </Button>
        )}
        {isAddVendorVisible && (
          // isAddVendorVisible
          <div className="">
            <Drawer
              anchor="right"
              open={isAddVendorVisible}
              onClose={closeAddVendor}
              sx={{
                "& .MuiDrawer-paper": {
                  height: "calc(100% - 20px)",
                  bottom: "20px",
                  width: "40%",
                },
              }}
            >
              <div className="w-100per">
                <NewVendor />
              </div>
            </Drawer>
          </div>
        )}
      </div>
      <div className=" bg-FFFFFF mx-10 ">
        <div className="flex space-x-4">
          <div className="w-full flex flex-col space-y-[20px] bg-F1F6F9 ">
            <div className="">
              <div className="flex justify-start gap-x-4 items-center bg-F1F6F9 ">
                <div className="text-18 text-1D4469 font-600">Name & contact</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsContactFormOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isContactFormOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isContactFormOpen && (
                <div className="p-5 bg-FFFFFF border rounded">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Vendor Name</div>

                          <div>
                            <Input
                              name="vendorName"
                              label="Enter Text"
                              placeholder="Enter Vendor Name"
                              value={formData.vendorName}
                              onChange={handleInputChange}
                              style={{ width: "100%", height: "35px" }}
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Vendor Display Name</div>
                        <div className="w-full">
                          <Input
                            name="vendorContactName"
                            label="Enter Text"
                            placeholder="Enter Vendor Contact Name"
                            value={formData.vendorContactName} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Email</div>
                        <div className="w-full">
                          <Input
                            name="email"
                            placeholder="Enter Email Address"
                            value={formData.email} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Phone Number</div>
                        <div className="w-full">
                          <Input
                            name="phoneNumber"
                            type={"number"}
                            placeholder="Enter Phone Number"
                            value={formData.phoneNumber} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-[50%] flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Mobile Number</div>

                        <div>
                          <Input
                            name="mobileNumber"
                            // label="dkd"
                            type={"number"}
                            placeholder="Enter Other Detail"
                            value={formData.mobileNumber}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Website</div>

                        <div>
                          <Input
                            name="website"
                            // label="Enter Text"
                            type={""}
                            placeholder="Enter Company Name"
                            value={formData.website}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="">
              <div className="flex justify-start gap-x-4 items-center">
                <div className="text-18 text-1D4469 font-600">Addresses</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsAddressFormOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isAddressFormOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isAddressFormOpen && (
                <div className="p-3 bg-FFFFFF border rounded">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Street Address 1</div>

                          <div>
                            <Input
                              name="streetAddress1"
                              label="Enter Text"
                              placeholder="Enter Address"
                              value={formData.streetAddress1}
                              onChange={handleInputChange}
                              style={{ width: "100%", height: "35px" }}
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Street Address 2</div>

                        <div>
                          <Input
                            name="streetAddress2"
                            // label="dkd"
                            placeholder="Enter Address"
                            value={formData.streetAddress2} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">City</div>

                        <div>
                          <Input
                            name="city"
                            // label="dkd"
                            placeholder="Enter City"
                            value={formData.city} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">State</div>

                        <div>
                          <Input
                            name="state"
                            // label="dkd"
                            placeholder="Enter State"
                            value={formData.state} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex gap-x-4">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">ZIP Code </div>

                        <div>
                          <Input
                            name="zipCode"
                            // label="dkd"
                            type={"number"}
                            placeholder="Enter Other Detail"
                            value={formData.zipCode}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-1 w-full">
                        <div className="text-14 font-400 text-434852">Country</div>

                        <div>
                          <Select
                            name="country"
                            placeholder={"Choose An Option"}
                            options={selectCountry} // Pass the options array
                            value={setSelectedCountry} // Bind the selected value to the state
                            onChange={handleCountrySelectChange} // Handle the change event
                            style={{
                              width: "100%",
                              height: "35px",
                              padding: "5px",
                            }}
                            className="w-full"
                          ></Select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="bg-F1F6F9">
              <div className="flex justify-between">
                <div className="flex justify-start gap-x-4 items-center ">
                  <div className="text-18 text-1D4469 font-600">Payment</div>
                  <div>
                    <button onClick={(e) => toggleVisibility(e, setIsPaymentTabOpen)}>
                      <DownAngelBracket
                        className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                          isPaymentTabOpen ? "" : "rotate-180"
                        }`}
                      />
                    </button>
                  </div>
                </div>
                <div>
                  <Button type="primary" onClick={handleAddAnotherAccount} style={{}}>
                    +Add Another Account
                  </Button>
                </div>
              </div>
              {isPaymentTabOpen && (
                <div className="p-5 bg-FFFFFF border rounded my-1">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Bank Name</div>

                          <div>
                            <Input
                              name="bankName"
                              label="Enter Bank Name"
                              placeholder="Enter Vendor Name"
                              value={formData.bankName}
                              onChange={handleInputChange}
                              style={{ width: "100%", height: "35px" }}
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Bank Address</div>
                        <div className="w-full">
                          <Input
                            name="bankAddress"
                            label=""
                            placeholder="Enter Bank Address"
                            value={formData.bankAddress} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Account Name</div>
                        <div className="w-full">
                          <Input
                            name="accountName"
                            placeholder="Enter Account Name"
                            value={formData.accountName} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Account Number</div>
                        <div className="w-full">
                          <Input
                            name="accountNumber"
                            placeholder="Enter Account Number"
                            value={formData.accountNumber}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-[50%] flex gap-x-4">
                      <div className="w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Name To Print on Check</div>
                        <div className="w-full">
                          <Input
                            name="nameToPrintonCheck"
                            // type={"number"}
                            placeholder="Enter Company Name"
                            value={formData.nameToPrintonCheck}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Routing Number</div>

                        <div>
                          <Input
                            name="routingNumber"
                            // label="dkd"
                            type={"number"}
                            placeholder="Enter Routing Number"
                            value={formData.routingNumber}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="">
              <div className="flex justify-start gap-x-4 items-center">
                <div className="text-18 text-1D4469 font-600">Additional Info</div>
                <div>
                  <button onClick={(e) => toggleVisibility(e, setIsAddiInfoTabOpen)} className="btn">
                    <DownAngelBracket
                      className={`h-[8px] text-1D4469 sidedownarrow  items-center ${
                        isAddiInfoTabOpen ? "" : "rotate-180"
                      }`}
                    />
                  </button>
                </div>
              </div>
              {isAddiInfoTabOpen && (
                <div className="p-5 bg-FFFFFF border rounded my-1">
                  <div className="flex flex-col gap-y-[20px]">
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Taxes</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-[24.5%] flex ">
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852 capitalize">
                          Business ID No. / Social Security No.
                        </div>

                        <div>
                          <Input
                            name="businessIDNo_SocialSecurityNo"
                            // label="dkd"
                            type={"text"}
                            placeholder="Enter ID No."
                            value={formData.businessIDNo_SocialSecurityNo}
                            onChange={handleInputChange}
                            style={{ width: "100%", height: "35px" }}
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex ">
                      <div className=" w-full flex  gap-x-1 items-center">
                        <div className="space-x-2">
                          <input
                            type="checkbox"
                            className="appearance-none  text-12 focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
                            style={{ boxShadow: "none" }}
                          />

                          <span className="text-[#2C495D] text-12 font-400">Track payments for 1099</span>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Payments</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-[50%] flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Terms</div>

                          <div className="w-full">
                            <Select
                              name="vendordispalyselect"
                              placeholder={"Select Terms"}
                              options={selectTermName} // Pass the options array
                              value={selectedTermValue} // Bind the selected value to the state
                              onChange={handleTermSelectChange} // Handle the change event
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full flex flex-col gap-y-1">
                        <div className="text-14 font-400 text-434852">Account Number</div>

                        <div>
                          <Input
                            name="account_Number"
                            // label="dkd"
                            placeholder="Enter Account Number"
                            type={"number"}
                            value={formData.account_Number} // Bind the input value to the state
                            onChange={handleInputChange} // Handle the change event
                            style={{ width: "100%", height: "35px" }} // Additional styling if needed
                          ></Input>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Accounting</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-[24.5%] flex ">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Default Expense Category</div>

                          <div className="w-full">
                            <Select
                              name="defaultExpenseCategory"
                              placeholder={"Choose An Option"}
                              options={selectDeExCatName}
                              value={setSelectedDeExCatValue}
                              onChange={handleDeExCatSelectChange}
                              style={{
                                width: "100%",
                                height: "35px",
                                padding: "5px",
                              }}
                              className="w-full"
                            ></Select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-600 text-2C495D">Opening Balance</div>
                        </div>
                      </div>
                    </div>
                    <div className="w-[50%] flex items-center space-x-4">
                      <div className=" w-full">
                        <div className="flex flex-col gap-y-1">
                          <div className="text-14 font-400 text-434852">Opening Balance</div>

                          <div>
                            <Input
                              name="openingBalance"
                              // label="Enter Text"
                              placeholder="00.00"
                              type={"number"}
                              value={formData.openingBalance} // Bind the input value to the state
                              onChange={handleInputChange} // Handle the change event
                              style={{ width: "100%", height: "35px" }} // Additional styling if needed
                            ></Input>
                          </div>
                        </div>
                      </div>
                      <div className=" w-full">
                        <div>
                          <div className="w-full flex flex-col gap-y-1">
                            <div className="text-14 font-400">Payment Date</div>
                            <div className="flex items-center bg-white   datePicker_container ">
                              <DatePicker
                                selected={OpeningBalanceDate}
                                onChange={onChange}
                                paymentDate={OpeningBalanceDate}
                                // endDate={endDate}
                                // selectsRange
                                placeholderText={placeholder}
                                dateFormat={displayFormat}
                                className=" w-[100%] flex-grow  rounded focus:outline-hidden focus:ring-0    active:border active:border-DFE2E5 text-gray-800 text-sm  h-[34px]  border border-gray-200"
                              ></DatePicker>

                              <div>
                                <CalendarWithTimeIcon></CalendarWithTimeIcon>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="text-14 font-400 flex justify-between items-center">
              <div>
                <button className="text-16 font-500 flex flex-col items-center justify-center text-center">
                  <div className="text-2999BC">Privacy</div>
                </button>
              </div>
              <div className="flex ">
                <div>
                  <Button type="primary" onClick={handleVendorCancel} style={{ margin: "10px" }}>
                    CANCEL
                  </Button>
                </div>
                <div>
                  <Button type="secondary" onClick={handleVendorSave} style={{ margin: "10px" }}>
                    SAVE
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutHOC(VendorHeaderHoc(VendorAdd));
